<template>
  <Sidebar
    v-model:visible="visible"
    header="Colaboración"
    position="right"
    class="messages-sidebar w-full md:w-20rem lg:w-30rem"
  >
    <div class="messages-container">
      <template v-for="(element, index) in chatElements" :key="index">
        <div v-if="element.type === 'date'" class="date">
          {{ element.content }}
        </div>
        <div
          v-if="element.type === 'message'"
          class="message"
          :class="`message-${element.direction}`"
        >
          <div class="message-user">
            <div class="message-user-initials">{{ element.user.initials }}</div>
            <div class="message-user-name">{{ element.user.name }}</div>
          </div>
          <div class="message-content">
            {{ element.content }}
          </div>
          <div class="message-time">{{ element.time }}</div>
        </div>
      </template>
    </div>

    <div class="input-text">
      <InputGroup class="w-full h-full">
        <InputText type="text" v-model="value" placeholder="Envía un mensaje" />
        <InputGroupAddon class="send-message-button cursor-pointer">
          <i class="pi pi-send"></i>
        </InputGroupAddon>
      </InputGroup>
    </div>
  </Sidebar>
  <Button
    v-if="false"
    icon="pi pi-comments"
    @click="visible = true"
    class="open-chat-button"
    rounded
  />
</template>

<script setup>
import { ref, watch, nextTick } from "vue";
import Sidebar from "primevue/sidebar";
import Button from "primevue/button";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputText from "primevue/inputtext";

// #region Props, Emits
// #endregion

// #region  Params, Ref, Reactives, Computed
const visible = ref(false);
const chatElements = ref([
  {
    user: {
      name: "Nombre Apellido",
      initials: "NA",
    },
    content:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam quidem similique deserunt architecto doloremque! Vel dolor temporibus aliquam dicta, in molestiae veritatis totam deserunt fuga, aspernatur aliquid voluptate fugiat? Possimus?", // eslint-disable-line
    time: "10:00",
    type: "message",
    direction: "incoming",
  },
  {
    user: {
      name: "Nombre Apellido",
      initials: "NA",
    },
    content:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam quidem similique deserunt architecto doloremque! Vel dolor temporibus aliquam dicta, in molestiae veritatis totam deserunt fuga, aspernatur aliquid voluptate fugiat? Possimus?", // eslint-disable-line
    time: "10:00",
    type: "message",
    direction: "outcoming",
  },
  {
    content: "01/01/2020",
    type: "date",
  },
  {
    user: {
      name: "Nombre Apellido",
      initials: "NA",
    },
    content:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam quidem similique deserunt architecto doloremque! Vel dolor temporibus aliquam dicta, in molestiae veritatis totam deserunt fuga, aspernatur aliquid voluptate fugiat? Possimus?", // eslint-disable-line
    time: "10:00",
    type: "message",
    direction: "incoming",
  },
  {
    content: "01/01/2020",
    type: "date",
  },
  {
    user: {
      name: "Nombre Apellido",
      initials: "NA",
    },
    content:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam quidem similique deserunt architecto doloremque! Vel dolor temporibus aliquam dicta, in molestiae veritatis totam deserunt fuga, aspernatur aliquid voluptate fugiat? Possimus?", // eslint-disable-line
    time: "10:00",
    type: "message",
    direction: "outcoming",
  },
]);
// #endregion

// #region Functions
function scrollToEnd() {
  nextTick(() => {
    const messagesContainer = document.querySelector(".messages-container");

    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  });
}
// #endregion

// #region Effects, Hooks
watch(visible, (value) => {
  if (value) {
    scrollToEnd();
  }
});
// #endregion

// #region Provide, Expose
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.input-text {
  padding: 1rem;
  background-color: #f0f0f0;
  height: 8%;

  .send-message-button:hover {
    transition: $transition;
    background-color: #e3e4e7;
  }
}

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  padding: 1rem;
  height: 92%;
  overflow-y: auto;

  .date {
    text-align: center;
    font-size: 0.8rem;
    background-color: black;
    color: white;
    margin: auto;
    border-radius: 0.5rem;
    padding: 0.5rem;
    margin-top: 1rem;
  }

  .message {
    position: relative;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    max-width: 80%;

    &:after {
      content: "";
      position: absolute;
      border-style: solid;
      display: block;
      width: 0;
      z-index: 1;
      top: 10px;
    }

    &-incoming {
      align-self: flex-start;
      background-color: #a8ddfd;
      transform: translateX(10px);

      &:after {
        border-width: 10px 10px 10px 0;
        border-color: transparent #a8ddfd;
        left: -10px;
      }
    }

    &-outcoming {
      align-self: flex-end;
      background-color: #f0f0f0;
      transform: translateX(-10px);

      &:after {
        border-width: 10px 0 10px 10px;
        border-color: transparent #f0f0f0;
        right: -10px;
      }
    }

    .message-user {
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem;

      .message-user-initials {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.5rem;
      }

      .message-user-name {
        font-weight: bold;
        font-size: 0.8rem;
      }
    }

    .message-time {
      font-size: 0.7rem;
      margin-top: 0.5rem;
    }
  }
}

.open-chat-button {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: $open-chat-button-z-index;
}
</style>

<style lang="scss">
.messages-sidebar {
  .p-sidebar-content {
    padding: 0;
  }
}
</style>
